import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { getListViewState, type TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

/**
 * Selects a TableView that has already been pre-loaded into the store, without
 * triggering another row fetch. This is used today for Priority View when the user
 * clicks again on the "Ready" state Priority view button after pre-fetching completes in the background.
 */
export default function selectPrefetchedTableView(newTableView: TableView): void {
    const oldTableView = getSelectedTableView();
    if (oldTableView === newTableView) {
        return;
    }

    setSelectedTableViewIdMutator(newTableView.id);
}

const setSelectedTableViewIdMutator = mutatorAction(
    'setSelectedTableViewIdForPrefetch',
    (id: string) => {
        getListViewState().selectedTableViewId = id;
    }
);
